import { StyleSheet } from 'aphrodite';
import { kitTintColor } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	childRoute: {
		boxSizing: 'border-box',
		height: '100%',
		overflow: 'auto',
	},
	container: {},
	notifyClientsCheckbox: {
		color: kitTintColor,
		fontSize: 16,
	},
	notifyClientsContainer: {
		display: 'flex',
		justifyContent: 'center',
		margin: '10px 0px 25px 0px',
	},
});
